export default __webpack_public_path__ + "static/media/ic_green_check_circle.2586f05d.svg";